import { useContext } from 'react';
import { ToastContext } from '../components/Toast';

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    // Fallback if ToastProvider is not available
    return {
      showToast: (message: string, type?: 'success' | 'error' | 'info') => {
        if (type === 'error') {
          console.error(message);
        } else {
          console.log(message);
        }
      },
    };
  }
  return context;
};

